import React, { useState } from 'react';
import { AssessmentState } from './src/types';
import { AssessmentForm } from './src/components/AssessmentForm';
import { ResultsView } from './src/components/ResultsView';
import { AnimatePresence } from 'framer-motion';
export function App() {
  const [view, setView] = useState<'form' | 'results'>('form');
  const [state, setState] = useState<AssessmentState>({
    penilai: '',
    jenjang: '',
    kelas: '',
    student: '',
    scores: {}
  });
  const handleStateChange = (updates: Partial<AssessmentState>) => {
    setState(prev => ({
      ...prev,
      ...updates
    }));
  };
  return <div className="min-h-screen bg-[#f5f5f7] w-full" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {view === 'form' ? <AssessmentForm key="form" state={state} onChange={handleStateChange} onSubmit={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        setView('results');
      }} data-id="element-2" /> : <ResultsView key="results" state={state} onBack={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        setView('form');
      }} data-id="element-3" />}
      </AnimatePresence>
    </div>;
}